<div class="stock-allocation-content" [class.order-allocation-content]="activeTab == 2"
     [class.stock-allocation-order-detail]="!isDashboard && !isSummary && !darkCards"
     [class.read-only-mode]="isReadOnly">
    <!-- ✅ Loader only shows during drag-and-drop operations (isLoading=true) -->
    <div class="page-loader" [class.d-none]="!isLoading"></div>

    <!-- Custom drag preview to fix horizontal scroll drag preview issue -->
    <div id="customDragPreview" class="custom-drag-preview">
        <span class="drag-preview-order-date"></span>
        <span class="drag-preview-order"></span>
        <span class="drag-preview-qty"></span>
        <span class="drag-preview-stock-required-date"></span>
    </div>
    @if (shouldShowSkeleton) {
        <ng-container *ngTemplateOutlet="panelSkeleton"></ng-container>
    } @else if (unitBoardBlockedReason) {
        <!--
          Nothing to allocate against yet — almost always a recipe that has not come back from
          Unleashed. Said plainly, because an empty card strip reads as a broken screen.
        -->
        <p class="unit-board-blocked">{{ unitBoardBlockedReason }}</p>
    } @else {
        @if (!isSummary) {
            <ng-container
                *ngTemplateOutlet="block; context: { $implicit: 'Unassigned Stock', dataList: unassignedStock, 'isCardLoading': isUnassignedStockLoading }"></ng-container>
            <ng-container
                *ngTemplateOutlet="block; context: { $implicit: 'Stock On Hand', dataList: stockOnHand, 'isCardLoading': isStockOnHandLoading }"></ng-container>
        }
        @for (container of containers; track container; let i = $index) {
            <ng-container
                *ngTemplateOutlet="block; context: { $implicit: container.id, dataList: container?.products, container: container, containerIndex: i }"></ng-container>
        }
        @if (!isSummary && !isReadOnly) {
            <div class="card-wrap add-container">
                <button type="button" class="add-container-btn" (click)="handleAddContainerSidebarClick()">
                    + Add New Container
                </button>
            </div>
        }
    }
</div>

<ng-template #panelSkeleton>
    <!-- Unassigned Stock skeleton -->
    <div class="card-wrap skeleton-card stock-allocation-panel-skeleton"
         [class.selected]="skeletonSelectedCard === 'Unassigned Stock'" aria-hidden="true">
        <div class="card-head">
            <div class="skeleton-line w-50 h-22"></div>
        </div>
        <div class="qty-box-wrap">
            <div class="qty-box skeleton-qty-box">
                <div class="skeleton-line w-80 h-12 mb-1"></div>
                <div class="skeleton-line w-50 h-16"></div>
            </div>
        </div>
        <div class="skeleton-table-header"></div>
        @for (row of [1, 2, 3]; track row) {
            <div class="skeleton-table-row">
                <div class="skeleton-line w-25 h-14"></div>
                <div class="skeleton-line w-30 h-14"></div>
                <div class="skeleton-line w-15 h-14"></div>
                <div class="skeleton-line w-15 h-14"></div>
            </div>
        }
    </div>

    <!-- Stock On Hand skeleton -->
    <div class="card-wrap skeleton-card stock-allocation-panel-skeleton stock-on-hand-skeleton"
         [class.selected]="skeletonSelectedCard === 'Stock On Hand'" aria-hidden="true">
        <div class="card-head">
            <div class="skeleton-line w-50 h-22"></div>
        </div>
        <div class="qty-box-wrap">
            @for (box of [1, 2, 3]; track box) {
                <div class="qty-box skeleton-qty-box">
                    <div class="skeleton-line w-80 h-12 mb-1"></div>
                    <div class="skeleton-line w-50 h-16"></div>
                </div>
            }
        </div>
        <div class="skeleton-table-header"></div>
        @for (row of [1, 2, 3]; track row) {
            <div class="skeleton-table-row">
                <div class="skeleton-line w-25 h-14"></div>
                <div class="skeleton-line w-30 h-14"></div>
                <div class="skeleton-line w-15 h-14"></div>
                <div class="skeleton-line w-15 h-14"></div>
            </div>
        }
    </div>

    <!-- Dynamic container skeleton cards (mirror the populated layout's container cards) -->
    @for (i of skeletonContainerPlaceholders; track i) {
        <div class="card-wrap skeleton-card stock-allocation-panel-skeleton container-skeleton"
             [class.selected]="skeletonSelectedCard === 'container' && i === 0" aria-hidden="true">
            <div class="card-head">
                <div class="skeleton-line w-50 h-22"></div>
            </div>
            <div class="qty-box-wrap">
                @for (box of [1, 2, 3]; track box) {
                    <div class="qty-box skeleton-qty-box">
                        <div class="skeleton-line w-80 h-12 mb-1"></div>
                        <div class="skeleton-line w-50 h-16"></div>
                    </div>
                }
            </div>
            <div class="skeleton-table-header"></div>
            @for (row of [1, 2, 3]; track row) {
                <div class="skeleton-table-row">
                    <div class="skeleton-line w-25 h-14"></div>
                    <div class="skeleton-line w-30 h-14"></div>
                    <div class="skeleton-line w-15 h-14"></div>
                    <div class="skeleton-line w-15 h-14"></div>
                </div>
            }
        </div>
    }

    <!-- Add New Container skeleton -->
    @if (!isReadOnly) {
        <div class="card-wrap add-container skeleton-card stock-allocation-panel-skeleton" aria-hidden="true">
            <div class="skeleton-line skeleton-add-container-btn"></div>
        </div>
    }
</ng-template>

<ng-template #block let-title let-dataList="dataList" let-container="container" let-containerIndex="containerIndex"
             let-isCardLoading="isCardLoading">
    <div class="card-wrap" (dragover)="onMouseEnter(title)" (dragleave)="onMouseLeave(title)"
         [ngClass]="{'selected': !isReadOnly && (assembledUnitBoard ? isAssembledCardActive(dataList) : ((title == 'Unassigned Stock' && !stock_available && !containerId) || (title == 'Stock On Hand' && stock_available && checkStockOnHandActive(dataList)) || (title != 'Unassigned Stock' && title != 'Stock On Hand' && (containerId == container?.id || checkContainerActive(container?.products))))) && (!isDashboard || (isDashboard && activeTab == 2))}"
         [style.background]="title == 'Unassigned Stock' && !dataList?.length && isDashboard ? '#1D1E1F' : ''"
         [class.container-management-card]="isContainerManagement">
        @if (isCardLoading) {
            <div class="widget-page-loader"></div>
        }
        <div class="card-head">
            <div class="card-head-left-side">
                <h3 class="card-title">
                    @if (!isSummary) {
                        <span class="card-title-inner">{{ container ? container.order_number : title }}</span>
                    }
                    <!--
                      Assembled unit mode: the card counts assembled units, so the component
                      quantities behind that number live here rather than on the card face.
                    -->
                    @if (assembledUnitBoard && unitCard(title, container)?.components?.length) {
                        <!-- The working behind the card's figure; shared with the Summary tab so both explain it alike. -->
                        <app-assembled-card-info [card]="unitCard(title, container)" [unleashed]="unitBoardUnleashed"
                                                 [uom]="uom"
                                                 [dark]="isDashboard || isSummary || darkCards"></app-assembled-card-info>
                    }
                    @if (title == 'Stock On Hand' && isStockOnHandOverallocated()) {
                        <span class="status over-allocated-status pulse-effect">
              Overallocated
            </span>
                    }
                    @if (container) {
                        <span class="status {{convertToSlug(container?.status?.name)}}">
                        {{ container?.status?.name }}
            </span>
                        @if (container?.total_qty < container?.allocated_qty) {
                            <span class="status over-allocated-status pulse-effect">
              Overallocated
              </span>
                        }
                    }
                    @if (title != 'Unassigned Stock') {
                        <span class="other-info">
              <ng-container *ngIf="container">
              <span class="eta">
                <span [tooltip]="'Anticipated Warehouse Arrival Date'" placement="top">ETA:</span>
                <strong>{{ container?.anticipated_warehouse_arrival_date ? (container.anticipated_warehouse_arrival_date | date: 'dd/MM/yyyy') : '-' }}</strong>
              </span>
                  @if (!isSummary) {
                      <span class="eta">
                  <span [tooltip]="'Anticipated Production Completion Date'" placement="top">APCD:</span>
                  <strong>{{ container?.anticipated_production_completion_date ? (container.anticipated_production_completion_date | date: 'dd/MM/yyyy') : '-' }}</strong>
                </span>
                  }
              </ng-container>

              <ng-container
                  *ngIf="title == 'Stock On Hand' && isStockOnHandOverallocated() && quantityData?.pendingTasks?.length > 0">
                <span class="fa fa-bullhorn" [tooltip]="followupTooltip1"></span>
                <ng-template #followupTooltip1>
                  <div *ngFor="let task of quantityData.pendingTasks; let last = last">
                    <p class="tooltip-custom-class"
                       [style.margin-bottom]="last ? '0' : (quantityData.pendingTasks.length > 1 ? '10px' : '0')">
                    <span class="tooltip-title">{{ task?.taskCategory?.title }}
                        ({{ task?.task_number }}): </span>
                      <span class="tooltip-action">{{ task?.action || task?.taskCategory?.action }}</span>
                      <br>
                      <strong>Assigned admin</strong>: {{ task?.assignedTo?.first_name + ' ' + task?.assignedTo?.last_name }}
                    </p>
                  </div>
                </ng-template>
                <span *ngIf="(quantityData.pendingTasks | rescheduledNotes).length" class="rescheduled-note-flag"
                      [tooltip]="rescheduledNoteTpl1" [tooltipClass]="'custom-tooltip-class'" container="body" placement="bottom">
                  <i class="far fa-comment"></i>
                </span>
                <ng-template #rescheduledNoteTpl1>
                  <p class="tooltip-custom-class" *ngFor="let rTask of (quantityData.pendingTasks | rescheduledNotes)">
                    <strong>{{ rTask.task_number }}:</strong> {{ rTask.note }}
                  </p>
                </ng-template>
              </ng-container>
              <ng-container *ngIf="container?.pendingTasks?.length > 0">
                <span class="fa fa-bullhorn" [tooltip]="followupTooltip"></span>
                <ng-template #followupTooltip>
                  <div *ngFor="let task of container.pendingTasks; let last = last">
                    <p class="tooltip-custom-class"
                       [style.margin-bottom]="last ? '0' : (container.pendingTasks.length > 1 ? '10px' : '0')">
                    <span class="tooltip-title">{{ task?.task_category?.title ? task?.task_category?.title : task.title }}
                        ({{ task.task_number }}): </span>
                      <span class="tooltip-action">{{ task?.task_category?.action ? task?.task_category?.action : task.action }}</span>
                      <br>
                      <strong>Assigned admin</strong>: {{ (task?.backend_user?.first_name ? task?.backend_user?.first_name : task.first_name) + ' ' + (task?.backend_user?.last_name ? task?.backend_user?.last_name : task.last_name) }}
                    </p>
                  </div>
                </ng-template>
                <span *ngIf="(container.pendingTasks | rescheduledNotes).length" class="rescheduled-note-flag"
                      [tooltip]="rescheduledNoteTpl2" [tooltipClass]="'custom-tooltip-class'" container="body" placement="bottom">
                  <i class="far fa-comment"></i>
                </span>
                <ng-template #rescheduledNoteTpl2>
                  <p class="tooltip-custom-class" *ngFor="let rTask of (container.pendingTasks | rescheduledNotes)">
                    <strong>{{ rTask.task_number }}:</strong> {{ rTask.note }}
                  </p>
                </ng-template>
              </ng-container>
            </span>
                    }
                </h3>
            </div>
            <!--
              The container's In Production delay history (each reschedule of its Add GPSM Reference
              task, with the reason), for sales to pass on to the customer. Shown wherever the card
              is, read-only ones included (the order page's allocation panel), so it sits outside
              the !isReadOnly guard that hides the edit actions.
            -->
            @let delayHistory = containerDelayHistory(container);
            @if (title != 'Unassigned Stock' && (!isReadOnly || delayHistory.length)) {
                <div class="card-head-right-side" [class.has-delay-history]="delayHistory.length">
                    @if (delayHistory.length) {
                        <button type="button" class="action-btn delay-history-btn" aria-label="In Production delay history"
                                tooltip="Delay history" container="body" (click)="openDelayHistory(container)">
                            <i class="far fa-history" aria-hidden="true"></i>
                        </button>
                    }
                    @if (!isReadOnly) {
                    @if (title == 'Stock On Hand') {
                        @if (isDashboard) {
                            <ng-select class="custom custom-dropdown-activity cursor-pointer" [items]="filters"
                                       dropdownPosition="bottom"
                                       (change)="onSelectFilterChange($event)" dropdownPosition="bottom"
                                       [appendTo]="'body'"
                                       bindLabel="name"
                                       bindValue="id" [clearable]="false" [ngModel]="1"
                                       [placeholder]="constants.DROPDOWN_FILTER_BY_TYPE"></ng-select>
                        }
                    } @else {
                        @if (container?.is_domestic_stock_transfer) {
                            <button type="button" class="action-btn pulse-effect-btn"
                                    (click)="handleAddContainerSidebarClick(container, containerIndex, true)"
                                    tooltip="Merge">
                                <img src="https://ik.imagekit.io/gatherco/WEBSITE_ASSET_STAGING/merge-icon.svg"
                                     width="20" height="20"
                                     alt="edit-icon">
                            </button>
                        }

                        @if (container?.status?.short_name == 'AAW' && !isSummary && !container?.is_domestic_stock_transfer) {
                            <button type="button" class="action-btn pulse-effect-btn"
                                    (click)="handleAddContainerSidebarClick(container, containerIndex, true)"
                                    tooltip="Merge">
                                <img src="https://ik.imagekit.io/gatherco/WEBSITE_ASSET_STAGING/merge-icon.svg"
                                     width="20" height="20"
                                     alt="edit-icon">
                            </button>
                        } @else {
                            @if (!isSummary) {
                                <button type="button" class="action-btn" tooltip="Edit"
                                        (click)="handleAddContainerSidebarClick(container, containerIndex)">
                                    <img src="https://ik.imagekit.io/gatherco/WEBSITE_ASSET_STAGING/edit-new-icon.svg"
                                         width="19"
                                         height="19" alt="edit-icon">
                                </button>
                            }
                        }
                    }
                    }
                </div>
            }
        </div>
        <div class="qty-box-wrap">
            <div class="qty-box">
                <label>Total Qty{{ uom ? ' (' + uom + ')' : '' }}</label>
                <span>
          @if (title == 'Unassigned Stock') {
              {{ (quantityData?.unAssignedStock?.total_qty ? quantityData?.unAssignedStock?.total_qty.toFixed(2) : 0) }}
          } @else {
              @if (title == 'Stock On Hand') {
                  {{ (quantityData?.onHandStock?.total_qty ? quantityData?.onHandStock?.total_qty.toFixed(2) : 0) }}
              } @else {
                  {{ (container?.total_qty ? container?.total_qty.toFixed(2) : 0) }}
              }
          }
                    <!--          {{ title == 'Unassigned Stock' ? (quantityData?.unAssignedStock?.total_qty ? quantityData?.unAssignedStock?.total_qty.toFixed(2) : 0) : title == 'Stock On Hand' ? (quantityData?.onHandStock?.total_qty ? quantityData?.onHandStock?.total_qty.toFixed(2) : 0) : (container?.total_qty ? container?.total_qty.toFixed(2) : 0) }}-->
        </span>
            </div>
            @if (title != 'Unassigned Stock') {
                <div class="qty-box">
                    <label>Allocated Qty{{ uom ? ' (' + uom + ')' : '' }}</label>
                    <span>{{
                            title == 'Stock On Hand' ? (quantityData?.onHandStock?.allocated_qty ?
                                    quantityData?.onHandStock?.allocated_qty.toFixed(2) : 0) :
                                (container?.allocated_qty ? container?.allocated_qty.toFixed(2) : 0)
                        }}</span>
                </div>
                <div class="qty-box">
                    <label>Available Qty{{ uom ? ' (' + uom + ')' : '' }}</label>
                    <span
                        [ngClass]="{'qty-count-box': title == 'Stock On Hand' ? !(quantityData?.onHandStock?.available_qty > 0) : !(container?.available_qty > 0), 'qty-positive': title == 'Stock On Hand' ? quantityData?.onHandStock?.available_qty > 0 : container?.available_qty > 0}">{{
                            title == 'Stock On Hand' ? (quantityData?.onHandStock?.available_qty ?
                                    quantityData?.onHandStock?.available_qty.toFixed(2) : 0) :
                                (container?.available_qty ? container?.available_qty.toFixed(2) : 0)
                        }}</span>
                </div>
            }
        </div>
        <div class="widget-loader-parent">
            <div class="stock-allocation-table">
                <table class="table">
                    <thead>
                    <tr>
                        <th>ORDER DATE</th>
                        <th>ORDER NO</th>
                        <th>QTY</th>
                        <th>SRD</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                        @for (data of dataList; track data; let i = $index) {
                            <!-- A despatched allocation covers stock that has already left the warehouse,
                                 so it must not be re-allocated to a container or to Unassigned Stock.
                                 Disabling the row's own drag is not enough: on an order this card sits
                                 inside the product line's <tbody>, which is draggable for reordering,
                                 so a press on a locked row started a drag of the WHOLE product line
                                 (its image as the ghost). Cancelling the mousedown stops any drag from
                                 starting here; clicks, like the open-order link, still fire.
                                 Goes through a void method: Angular calls preventDefault() on any
                                 listener that RETURNS false, so an inline `flag && ...` cancelled the
                                 mousedown of every row whose flag the API sends as false — no Stock
                                 On Hand row could be dragged at all. -->
                            <tr [dndDraggable]="{data: data, containerIndex: containerIndex}"
                                [dndDisableIf]="(disableDragAndDropBasedOnOrder || disableDragAndDrop || isReadOnly || data?.isDispatchedPending)"
                                [dndEffectAllowed]="'move'" (dndStart)="onDragStart($event, title, data)"
                                (dndEnd)="onDragEnd($event, dataList, i, title)"
                                (mousedown)="blockLockedRowPress($event, data)"
                                [class.active-order]="orderId === data?.quote?.id"
                                [class.locked-row]="data?.isDispatchedPending">
                                <td>
                                    {{ data?.quote?.orderCreatedActivity?.created_at ? (data?.quote?.orderCreatedActivity?.created_at | date: 'dd/MM/yyyy') : '-' }}
                                </td>
                                <td (click)="openOrderModal(data?.quote?.id); $event.stopPropagation();"
                                    class="text-golden cursor-pointer">
                                    <div class="action-icon">
                                        {{ data?.quote?.order_number }}
                                        @if (!isSummary) {
                                            <!-- A link and an <img> are natively draggable, and only
                                                 Chromium/WebKit honour the CSS -webkit-user-drag the locked row
                                                 sets; Firefox needs the attribute or it drags the icon off a
                                                 row that must not move. -->
                                            <a [routerLink]="['/orders/view/'+data?.quote?.id]" target="_blank"
                                               rel="noopener noreferrer"
                                               [attr.draggable]="data?.isDispatchedPending ? 'false' : null"
                                               (click)="$event.stopPropagation();" class="cursor-pointer">
                                                <img src="/assets/admin/images/open-link-icon.svg" width="22"
                                                     height="22" alt="open-link-icon" container="body"
                                                     [attr.draggable]="data?.isDispatchedPending ? 'false' : null"
                                                     tooltip="Open">
                                            </a>
                                        }
                                    </div>
                                    <!-- Despatched from the warehouse, but Unleashed is still holding the stock:
                                         an ordinary product until Unleashed dispatches a shipment for this line, an
                                         assembled one until its Unleashed Sales Order completes. The quantity is
                                         still counted in Allocated Qty (and so held out of Available Qty) until
                                         then, which is why the row is still here. The wording below suits both.
                                         Sits BELOW the order number rather than beside it: these cards are ~385px
                                         wide and the table already scrolls horizontally, so widening the ORDER NO
                                         column would push QTY and SRD further out of view. -->
                                    @if (data?.isDispatchedPending) {
                                        <span class="status despatched-status"
                                              container="body"
                                              tooltip="Despatched - Unleashed is still holding this stock, so it remains excluded from available stock.">
                                            Despatched
                                        </span>
                                    }
                                </td>
                                <td>
                                    {{ data?.quantity }}

                                    @if (data?.product?.unit_of_measurement?.name === constants.UNIT_OF_MEASUREMENT_SQM) {
                                        m<sup>2</sup>
                                    } @else {
                                        {{ data?.product?.unit_of_measurement?.name | lowercase }}
                                    }
                                </td>
                                <td>
                                    {{ data?.quote?.is_split_delivery ? ((data?.quote_schedule_delivery_product?.stock_required_date) ? ((data?.quote_schedule_delivery_product?.stock_required_date) | date: 'dd/MM/yyyy') : '-') : ((data?.quote?.stock_required_date) ? ((data?.quote?.stock_required_date) | date: 'dd/MM/yyyy') : '-') }}
                                </td>
                                <td>
                                    <div class="action-icon">
                                        <ng-container
                                            *ngIf="data?.pendingTasks?.length > 0 && title == 'Unassigned Stock'">
                                            <div class="other-info" *ngIf="taskHasCategory(data.pendingTasks)"
                                                 [tooltip]="followupTooltip"
                                                 container="body"><span class="fa fa-bullhorn"></span></div>
                                            <ng-template #followupTooltip>
                                                <div *ngFor="let task of data.pendingTasks; let last = last">
                                                    <p class="tooltip-custom-class"
                                                       [style.margin-bottom]="last ? '0' : (data.pendingTasks.length > 1 ? '10px' : '0')">
                                                        <ng-container *ngIf="task.taskCategory != null">
                            <span class="tooltip-title">{{ task.taskCategory.title }}
                                ({{ task.task_number }}): </span>
                                                            <span class="tooltip-action">{{
                                                                    task.taskCategory.action
                                                                }}</span>
                                                            <br>
                                                            <strong>Assigned admin</strong>: {{
                                                                task.assignedTo ?
                                                                    task.assignedTo.first_name + ' ' + task.assignedTo.last_name :
                                                                    '-'
                                                            }}
                                                        </ng-container>
                                                    </p>
                                                </div>
                                            </ng-template>
                                        </ng-container>

                                        <!--                <i class="far fa-comment" (click)="addComment(data); $event.stopPropagation();"-->
                                        <!--                   *ngIf="title != 'Unassigned Stock'"-->
                                        <!--                   [ngClass]="{'comment-custom-class': data.note ? data.note.trim() : ''}"></i>-->
                                        <div *ngIf="title != 'Unassigned Stock' && !isReadOnly"
                                             (click)="addComment(data); $event.stopPropagation();"
                                             class="cursor-pointer" [tooltip]="data.note ? 'Edit note' : 'Add note'"
                                             container="body">
                                            <img
                                                src="https://ik.imagekit.io/gatherco/WEBSITE_ASSET_STAGING/comment-icon.svg"
                                                width="24"
                                                height="24" alt="comment-icon"
                                                [attr.draggable]="data?.isDispatchedPending ? 'false' : null">
                                        </div>
                                    </div>
                                </td>
                            </tr>

                        }
                    <ng-container *ngIf="dataList?.length === 0 && !isCardLoading">
                        <tr>
                            <td colspan="11" class="text-center">No Product Added</td>
                        </tr>
                    </ng-container>
                    </tbody>
                </table>
                <div class="drop-box" dndDropzone (dndDrop)="onDrop($event, dataList, title, container)"
                     [dndDisableIf]="(disableDragAndDropBasedOnOrder || disableDragAndDrop || isReadOnly)"
                     [class.show]="isdragging == title && selectedCard && selectedCard != title && draggedProduct == activeIndex">
                    Drop Order Here
                </div>
            </div>
        </div>
    </div>
</ng-template>
